module.exports = __webpack_public_path__ + "static/media/report.1257a0ea.svg";